import { createMatchMediaConnect } from 'react-matchmedia-connect'

export default createMatchMediaConnect({
  isMobile: '(max-width: 767px)',
  isTablet: '(max-width: 991px)'
})()
